/**
 * Zod schema for `app/config/adminPreferences.json`.
 *
 * This file is generated once and manually kept in sync with the JSON
 * structure so we can parse+validate the config at runtime while also
 * inferring a precise TypeScript type for downstream code.
 */

import { z } from 'zod'

export const adminPreferencesSchema = z
	.object({
		title: z.string(),
		baseUrl: z.string().url().optional().default('http://localhost:3000'),
		auth: z.boolean(),

		brand: z
			.object({
				name: z.string().optional(),
				shortName: z.string().optional(),
				baseUrl: z.string().url().optional(),
				contactEmail: z.string().email().optional(),
				social: z
					.object({
						twitterUrl: z.string().url().optional(),
					})
					.optional()
					.default({}),
				description: z.string().optional(),
			})
			.optional()
			.default({}),

		features: z
			.object({
				multiLanguage: z.boolean(),
				// Admin studios feature flags (optional)
				configStudio: z.boolean().optional().default(true),
				emailStudio: z.boolean().optional().default(true),
				// Entity feature groups
				course: z.record(z.boolean()),
				topic: z.record(z.boolean()),
				resource: z.record(z.boolean()),
			})
			// Preserve additional nested feature groups (e.g. enrollments, artifacts, collections).
			.passthrough(),

		settings: z.object({
			enabled: z.boolean(),
			routes: z.record(z.string(), z.boolean()),
		}),

		i18n: z
			.object({
				defaultLanguage: z.string().min(2).max(5).optional().default('en'),
				supportedLngs: z
					.array(z.string().min(2).max(5))
					.optional()
					.default(['en', 'es']),
			})
			.optional()
			.default({ defaultLanguage: 'en', supportedLngs: ['en', 'es'] }),

		'app-sidebar': z.record(z.string(), z.boolean()).optional().default({}),
	})
	.strict()

export type AdminPreferences = z.infer<typeof adminPreferencesSchema>
